
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BaseIndividual } from 'ah-api-gateways';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import FileUploader from 'ah-common-lib/src/common/components/upload/FileUploader.vue';
import UboDocumentsEditor from './UboDocumentsEditor.vue';
import { getPhoneNumber } from 'ah-common-lib/src/helpers/calls';

@Component({
  components: {
    UboDocumentsEditor,
    FileUploader,
  },
})
export default class UboInfo extends Mixins(WithRequestManager) {
  @Prop({ required: true }) ubo!: BaseIndividual;

  getPhoneNumber = getPhoneNumber;
}
